import { useContext } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { GlobalContext } from '../../../services/context/DataContext'

const MenuItemMinimized = ({
  children,
  level,
  image,
  text,
  linkTo,
  noBottomBorder
}) => {
  const classes = useStyles({ noBottomBorder })
  const { activeTabData } = useContext(GlobalContext)
  const [activeTab, setActiveTab] = activeTabData
  const menuClicked = (activeTab === linkTo)

  const getImageAltText = () =>
    text.replace(/[\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g, '')

  return (
    <div
      className={`${classes.root} ${classes.level1} ${menuClicked && classes.menuClicked}`}
      onClick={() => linkTo && setActiveTab(linkTo)}
    >
      <img
        className={classes.menuItemImage}
        src={image}
        alt={getImageAltText()}
      />
    </div>
  )
}

export default MenuItemMinimized

const useStyles = makeStyles((theme, props) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingRight: '5px',
    paddingTop: '10px',
    paddingBottom: '10px',
    borderBottom: (props) =>
      props.noBottomBorder
        ? 'none'
        : `1px solid ${theme.palette.secondary.main}`,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.quaternary.main,
      color: theme.palette.primary.accent
    }
  },
  menuItemImage: {
    width: '20px',
    height: '20px',
    marginRight: '10px'
  },
  level0: {
    paddingLeft: '15px'
  },
  level1: {
    paddingLeft: '30px'
  },
  menuClicked: {
    backgroundColor: theme.palette.quaternary.main,
    color: theme.palette.primary.accent
  }
}))
